class Analitycs {
	constructor(modules, module_default, analytics, analytics_default, associates, currentUser, devices = []){
		// console.log("class Analytics **************************** ")
		this.modules               = modules;
	    this.module_default      = module_default;
	    this.analytics           = analytics;
	    this.analytics_default   = analytics_default;
	    this.associates 	       = associates;	
      this.currentUser         = currentUser
      this.devices             = devices;

	}	

	save_associate(act , item){ //  item = { create = device , update = analytics } 
          //save associate
          // console.log("Init states associate **************", act , item)
          // let list = this.list_devices;
          let licenses = this.analytics_default;

          let temp_associatives = []; // list associative
          let vm = this;          

          if (licenses && licenses.length > 0) {
            const find_license = licenses.some( function(arr_new, idx_new){
              if (arr_new.key == 'motion') {
                arr_new.active = true;
                return true;
              }
            })   
          }

          if (this.list_associate && this.list_associate.length > 0) {
            temp_associatives = this. list_associate;

          }

            // ****************************** CREATE *********************************
            // active default motion and add to associate
            if (act == 'create') {

              let license_default = this.analytics_default; // list analytics / analytics_default
              // let idx_list        = null;
              license_default.status = true;
              license_default.license = "demo";              

              let temp_list = licenses.some(function(lic, idx_lic){
                if (lic.key == 'motion') {
                  lic.license = license_default; // content the demo
                  // idx_list = idx_dev;
                  return true;
                }
              });
              
              // console.log('created associate', temp_list)
              if (temp_list) {

                // Device_Analytic: { deviceId, analytics: { licence } }

                let info_up = {
                  deviceId : item.deviceId,
                  analytics : licenses
                }
                temp_associatives.push(info_up);
                this.list_associate  = temp_associatives;
                vm.save_modules(temp_associatives, 'Device_Analytics');
                vm.save_parameters(temp_associatives, 'device_analytics')
              }
              
            } // create

            // ****************************** UPDATE *********************************
            if (item && act == 'update') { 
              if (temp_associatives && temp_associatives.length > 0) {
                const finded  =  temp_associatives.some( function(arr_dev, idx_dev){
                  if (arr_dev.deviceId == item.deviceId) {
                    let check = false;
                    if (!arr_dev.analytics) {
                      arr_dev.analytics = [];
                      arr_dev.analytics = licenses;
                    }
                    if (arr_dev.analytics && arr_dev.analytics.length > 0) {
                      // console.log('Associate ****************** 1')
                      check   = arr_dev.analytics.some( function (arr_check, idx_check){
                        if (arr_check.key == item.type) {
                          // console.log("******************* Match types", item.type, arr_check)
                          // arr_check.license = {};
                          arr_check.active = true;
                          arr_check.license = item; // Add new licence
                          return true;
                        }
                      }) // check
                    }

                    // console.log('Associate ****************** 2', check)
                    if (check) {                    
                      return true
                    }
                    return false;
                  } // finded
                })
                // console.log('Associate ****************** ', finded)
                if (finded) {
                  this.save_modules(temp_associatives, 'Device_Analytics');
                  this.update_parameters(temp_associatives, 'device_analytics')
                }
              }
            } // update


            if (act == 'delete') {
              let idx_del = null;
              let list_delete = [];
              if (temp_associatives && temp_associatives.length > 0) {
                const find = temp_associatives.some( function(arr_del, idx_del){
                  if (arr_del.deviceId == item.deviceId) {
                    if (arr_del.analytics && arr_del.analytics.length > 0) {
                      // 
                      arr_del.analytics.forEach(function (ar_dlt, idx_dlt){
                        if (ar_dlt.active) {
                          list_delete.push(ar_dlt.key);
                        }
                      })
                      // delete one analytic local
                      const find_del = arr_del.analytics.some(function(arr_dl, idx_dl){
                        if (arr_dl.type ==  item.type) {
                          idx_del = idx_dl;
                          return true;
                        }
                      })

                      if (find_del) {
                        /*arr_del.analytics =*/arr_del.analytics.splice(idx_del,1);
                        // console.log(arr_del.analytics, "******************** delete license")
                        return true
                      }
                      return false
                    }
                  }
                })
                /*if (find){
                }*/
                this.delete_modules(list_delete);

              }
            } // delete
            // ====================  check modules  ==========================
            if (act == 'check') {
              let list_actives = [];
              if (temp_associatives && temp_associatives.length > 0){
                temp_associatives.forEach( function(ar_active, idx_active){                  
                    if (ar_active.analytics && ar_active.analytics.length > 0) {
                      // 
                      ar_active.analytics.forEach(function (ar_actv, idx_dlt){
                        if (ar_actv.active) {
                          if (!list_actives.includes(ar_actv.key)) {
                            list_actives.push(ar_actv.key);
                          }
                        }
                      })
                    }                  
                })
                if (list_actives && list_actives.length > 0) {
                  // console.log("LIST Analytics Actives ************** : ", list_actives);
                  let analytics = this.list_licences && this.list_licences.length > 0 ? this.list_licences : null;

                  if (analytics) {
                    let sub_list = [];
                    analytics = analytics.filter(actives => {
                      if (actives.active == true){
                        sub_list.push(actives.key);
                      }
                    });
                    // console.log("LIST Current actives : ", sub_list);
                    list_actives.forEach(function(reactive, reactive_idx){
                      if (!sub_list.includes(reactive)) {
                        vm.module_render(reactive, 'new_module');
                      }
                    })
                  }

                }
              } // check
            }

            if (act == 'disable_analytic') {

            }
      } // save associate

}

module.exports = Analitycs;